import MonthlyInstallment from './MonthlyInstallment';
import MonthlyInstallmentUI from './MonthlyInstallmentUI';
var Installment = {
    Container: MonthlyInstallment,
    MonthlyInstallmentUI: MonthlyInstallmentUI
};
export default Installment;
